import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import {
  reset,
  stopSubmit
} from 'redux-form';
import ajax from '../../shared/ajax';
import AppError from '../../shared/AppError';
import { formName } from '../../containers/TechniciansReportForm/constants';
import { INVALID_TOKEN_CODE } from '../../shared/constants';
import actionsAndConstants from '../../shared/actionsAndConstants';

const {
  app: { actions: appActions },
  techniciansReportForm: {
    actions: techniciansReportFormActions,
    constants: techniciansReportFormConstants
  }
} = actionsAndConstants;

const createRegistry = action$ =>
  action$.ofType(techniciansReportFormConstants.createRegistry)
    .switchMap(({ payload: { ajaxOptions = {} } } = {}) =>
      ajax(ajaxOptions)
        .mergeMap(({ detalle, descripcion }) => (
          Observable.of(
            reset(formName),
            techniciansReportFormActions.createRegistrySucceeded({
              alert: {
                message: descripcion || 'Ha enviado el formulario exitosamente',
                type: 'success'
              },
              data: detalle[0]
            }),
            appActions.loadCatalogues()
          )
        ))
        .catch((error) => {
          if (error instanceof AppError && error.code === INVALID_TOKEN_CODE) {
            return Observable.of(
              appActions.invalidToken({
                alert: { message: error.description }
              })
            );
          }
          return Observable.of(
            stopSubmit(formName),
            techniciansReportFormActions.createRegistryFailed({
              alert: { message: error.description || error.message },
            })
          );
        }));

export default combineEpics(
  createRegistry
);



// WEBPACK FOOTER //
// ./src/epics/technicians/index.js